import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { InvoicingReportFilterModel } from 'src/app/models/invoicing/invoicing-report-filter.model';
import { ClientService } from 'src/app/services/archive/client.service';
import { ConstructionSiteService } from 'src/app/services/archive/construction-site.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoicingReportService } from 'src/app/services/invoicing/invoicing-report.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-invoicing-client-construction-site',
  templateUrl: './invoicing-client-construction-site.component.html',
  styleUrls: ['./invoicing-client-construction-site.component.scss'],
  standalone: false
})
export class InvoicingClientConstructionSiteComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredEnterprise: any[] = [];
  formInvoicingReportFilter: FormGroup = new FormGroup({});
  listBranch: any[] = [];
  listClient: any[] = [];
  listConstructionSite: any[] = [];
  listCostCenter: any[] = [];
  listEnterprise: any[] = [];
  listReportLevel: CustomListDropdown[] = [{ label: 'C.Costos', value: 1 }, { label: 'Obra', value: 2 }, { label: 'Cliente', value: 3 }];
  nameWindow: string = 'Informe de Facturación por Cliente-Obra-C.Costos';
  projectName = ProjectName.projectName;

  constructor(private branchService: BranchService,
    private clientService: ClientService,
    private constructionSiteService: ConstructionSiteService,
    private costCenterService: CostCenterService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private invoicingReportService: InvoicingReportService,
    private rentalPeriodService: RentalPeriodService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getAllLists();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeBranch(branchId: number | null) {
    this.filterEnterpriseByBranchId(branchId);
    if (branchId != 0 && branchId != null) {
      this.getFirstEnterpriseByBranch(branchId);
      this.formInvoicingReportFilter.controls["clientId"].patchValue(0);
      this.formInvoicingReportFilter.controls["constructionSiteId"].patchValue(0);
      this.formInvoicingReportFilter.controls["costCenterId"].patchValue(0);
    } else {
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
      this.formInvoicingReportFilter.controls["branchId"].patchValue(0);
      this.formInvoicingReportFilter.controls["clientId"].patchValue(0);
      this.formInvoicingReportFilter.controls["constructionSiteId"].patchValue(0);
      this.formInvoicingReportFilter.controls["costCenterId"].patchValue(0);
    }
    this.changeFilter();
  }

  async changeClient(clientId: number) {
    this.formInvoicingReportFilter.controls["constructionSiteId"].patchValue(0);
    this.formInvoicingReportFilter.controls["costCenterId"].patchValue(0);
    this.changeFilter();
    if (clientId && clientId !== 0) {
      this.listConstructionSite = await firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(clientId));
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(clientId, 0));
    } else {
      this.listConstructionSite = await firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(0));
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0));
      this.formInvoicingReportFilter.controls["clientId"].patchValue(0);
    }
  }

  async changeConstructionSite(constructionSiteId: number) {
    this.formInvoicingReportFilter.controls["costCenterId"].patchValue(0);
    this.changeFilter();
    if (constructionSiteId && constructionSiteId !== 0) {
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, constructionSiteId));
    } else {
      this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0));
      this.formInvoicingReportFilter.controls["constructionSiteId"].patchValue(0);
    }
  }

  changeCostCenter(costCenterId: number | null) {
    if (costCenterId === 0 || costCenterId === null || costCenterId === undefined) {
      this.formInvoicingReportFilter.controls["costCenterId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeEnterprise(enterpriseId: number | null) {
    if (enterpriseId != 0 && enterpriseId != null) {
      const branchId = this.listEnterprise.find(x => x.value === enterpriseId)!.branchId;
      this.formInvoicingReportFilter.controls["branchId"].patchValue(branchId);
    } else {
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  async clear() {
    this.changeFilter();
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
    this.listConstructionSite = await firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(0));
    this.listCostCenter = await firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0));
  }

  async exportExcel() {
    if (this.changeFilters) {
      const modelInvoicingReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;
      const typeReportValue = this.formInvoicingReportFilter.get("typeReport")?.value;
      let reportSuffix = '';
      switch (typeReportValue) {
        case 1:
          reportSuffix = 'C.Costos';
          break;
        case 2:
          reportSuffix = 'Obra';
          break;
        case 3:
          reportSuffix = 'Cliente';
          break;
        default:
          reportSuffix = 'General';
          break;
      }
      const fileName = `Informe de Facturación por Cliente-Obra-C.Costos - ${reportSuffix}.xlsx`;
      try {
        const response = await firstValueFrom(this.invoicingReportService.exportInvoicingReportInvoicingClientConstructionSiteCostCenter(modelInvoicingReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterEnterpriseByBranchId(branchId: number | null) {
    if (branchId != null) {
      this.filteredEnterprise = this.listEnterprise.filter(x => x.branchId === branchId);
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    } else {
      this.filteredEnterprise = this.listEnterprise;
    }
  }

  async getAllLists() {
    try {
      const [branches, enterprises, clients, constructionSites, costCenters] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllEnterprisesForSelectAsync()),
        firstValueFrom(this.clientService.getAllClientsForSelectAsync()),
        firstValueFrom(this.constructionSiteService.getAllConstructionSitesByClientIdForSelectAsync(0)),
        firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0)),
      ]);
      this.listBranch = branches;
      this.listEnterprise = enterprises;
      this.filteredEnterprise = this.listEnterprise;
      this.listClient = clients;
      this.listConstructionSite = constructionSites;
      this.listCostCenter = costCenters;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formInvoicingReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.getLastRentalPeriod(branch.branchId);
      this.filterEnterpriseByBranchId(branch.branchId);
      this.getFirstEnterpriseByBranch(branch.branchId);
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
      if (!response) {
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
      } else {
        this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(response.enterpriseId);
      }
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formInvoicingReportFilter.controls["initialDate"].patchValue(this.dateConverterService.convertDatePreserveDay(rentalPeriod.initialDate));
      this.formInvoicingReportFilter.controls["finalDate"].patchValue(this.dateConverterService.convertDatePreserveDay(rentalPeriod.finalDate));
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formInvoicingReportFilter.controls).forEach(key => {
      const control = this.formInvoicingReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInvoicingReportFilter.valid) {
      const modelInvoicingReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;

      if (modelInvoicingReportFilter.finalDate < modelInvoicingReportFilter.initialDate) {
        this.toastHandlerService.showToast('warning', 'La fecha final no puede ser menor al fecha inicial.');
        return;
      }

      try {
        this.dataReport = await firstValueFrom(this.invoicingReportService.getInvoicingClientConstructionSiteCostCenter(modelInvoicingReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      typeReport: {
        required: 'El campo Nivel es obligario.'
      },
      initialDate: {
        required: 'El campo Desde es obligatorio.'
      },
      finalDate: {
        required: 'El campo Hasta es obligatorio.'
      },
      clientId: {
        notNumber: 'Debe seleccionar un cliente válido.'
      },
      constructionSiteId: {
        notNumber: 'Debe seleccionar una Obra válida.'
      },
      costCenterId: {
        notNumber: 'Debe seleccionar un C.Costos válido.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoicingReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formInvoicingReportFilter = this.formBuilder.group({
      typeReport: [1, [Validators.required]],
      initialDate: ['', [Validators.required]],
      finalDate: ['', [Validators.required]],
      branchId: [0],
      enterpriseId: [0],
      clientId: [0, [CustomValidators.numberOnlyValidator()]],
      constructionSiteId: [0, [CustomValidators.numberOnlyValidator()]],
      costCenterId: [0, [CustomValidators.numberOnlyValidator()]]
    });
  }

}
